
import styled from 'styled-components';
import { ExternalContentCardProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import MarkdownParser from '@/components/molecules/MarkdownParser';
import { Svg } from '@/components/styled';
import { Monitor } from '@/public/img/icons';
import devices from '@/utilities/devices';

// #region STYLE
const ExternalContentCardContainer = styled.div`
	display: flex;
	border-radius: 10px;
	box-shadow: 0px 0px 10px rgba(63, 6, 43, 0.1), 0px 0px 50px rgba(63, 6, 43, 0.03), 0px 0px 70px rgba(63, 6, 43, 0.02);
	cursor: default;
	flex-direction: column;
	justify-content: space-between;
	min-height: 23.75rem;
	padding: 1.25rem 2.5rem;
	width: 32.5rem;
	transition: .3s;

	.content-container {
		display: flex;
		flex-direction: column;
		justify-content: center;

		.title-container {
			align-items: center;
			display: flex;
			flex-direction: column;

			.title {
				color: ${({ theme }) => theme.color.prune};
				font-weight: bold;
				font-size: ${({ theme }) => theme.fontSize.XXLARGE};
				margin-top: -5px;
			}
		}

		.subject-container {
			border: ${({ theme }) => `1px solid ${theme.color.grey}`};
			border-radius: 10px;
			color: ${({ theme }) => theme.color.black};
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: ${({ theme }) => theme.fontSize.LARGE};
			margin: 1.25rem 0;
			min-height: 6.25rem;
			padding: 0.625rem;
			text-align: center;
		}

		.details-container {
			color: ${({ theme }) => theme.color.greyDarker};
			text-align: center;
		}
	}

	:hover {
		transform: translateY(-3px);
		box-shadow: 0px 0px 20px rgba(63, 6, 43, 0.1), 0px 0px 60px rgba(63, 6, 43, 0.03), 0px 0px 80px rgba(63, 6, 43, 0.02);
	}

	@media screen and (${devices.mobile}) {
		margin: 1rem 0;
		padding: 1.25rem;
		width: 90%;
		.button-container {
			> div {
				padding: 1rem 0 .3rem;
				> a {
					margin: 0;
				}
			}
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		margin: 1rem 0;
		padding: 1.25rem;
		width: 90%;
		.button-container {
			> div {
				padding: 1rem 0 .3rem;
				> a {
					margin: 0;
				}
			}
		}
	}
`;
// #endregion

const ExternalContentCard = ({ content }: { content: ExternalContentCardProps }) => {
	return (
		<ExternalContentCardContainer>
			<div className='content-container'>
				<div className='title-container'>
					<Svg path='red'>
						<Monitor />
					</Svg>
					<div className='title'>
						{content.title}
					</div>
				</div>

				<div className='subject-container'>
					{content.subject}
				</div>
				{content.details && (
					<div className='details-container'>
						<MarkdownParser>
							{content.details}
						</MarkdownParser>
					</div>
				)}
			</div>
			<div className='button-container'>
				<Button_v2
					openOnNewTab={content?.cardButton?.newTab}
					href={content.cardButton?.url ?? '#'}
					text={content.cardButton?.text ?? '#'}
					version={content.cardButton?.variant ?? 'whiteOnRed'}
					gtm_id={content.cardButton?.trackerId ?? ''}
				/>
			</div>
		</ExternalContentCardContainer>
	);
};

export default ExternalContentCard;
